"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _hover = require("../../hooks/hover");
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Button = _interopRequireDefault(require("../Button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PremiumSourceModal = function PremiumSourceModal(_ref) {
  var isOpen = _ref.isOpen,
    toggle = _ref.toggle,
    source = _ref.source;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useHover = (0, _hover.useHover)(),
    hovered = _useHover.hovered,
    targetProps = _useHover.targetProps;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    disableBackdropClick: true,
    fullWidth: true,
    maxWidth: "md",
    open: isOpen,
    onClose: toggle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center px-8 py-10"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    width: "640",
    height: "640",
    alt: source,
    className: "w-24 inline-block",
    src: t("premium.subscription.".concat(source, ".logo"))
  }), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-2xl font-bold py-4"
  }, t("premium.subscription.".concat(source, ".title"))), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-light px-8"
  }, t("premium.subscription.".concat(source, ".description"))), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
    className: "!mr-0 py-4",
    control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      size: "small",
      iconsize: "small",
      name: "acknowledge",
      checked: checked,
      outerHovered: hovered,
      onChange: function onChange() {
        return setChecked(!checked);
      }
    }),
    label: /*#__PURE__*/_react["default"].createElement("p", (0, _extends2["default"])({}, targetProps, {
      className: "text-sm text-dark font-semibold select-none"
    }), t("premium.subscription.".concat(source, ".checkbox")))
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: !checked,
    onClick: toggle,
    className: "w-56 inline-block"
  }, t('button.gotIt'))));
};
var _default = exports["default"] = PremiumSourceModal;
//# sourceMappingURL=PremiumSourceModal.js.map